import script from "./CabecalhoFormGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./CabecalhoFormGroup.vue?vue&type=script&setup=true&lang=js"

import "./CabecalhoFormGroup.vue?vue&type=style&index=0&id=8dd8f10e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8dd8f10e"]])

export default __exports__